import React from "react";

export default function EditPersonalForm({ initial, onSubmit, onCancel }) {
  const [form, setForm] = React.useState(initial);
  React.useEffect(() => setForm(initial), [initial]);

  const change = (e) =>
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));
  const submit = (e) => {
    e.preventDefault();
    onSubmit(form);
  };

  const input = (name, label, type = "text", extra = {}) => (
    <label style={{ display: "grid", gap: 6 }}>
      <span>{label}</span>
      <input
        type={type}
        name={name}
        value={form[name] || ""}
        onChange={change}
        {...extra}
        style={{
          height: 38,
          padding: "8px 10px",
          border: "1px solid #E5E7EB",
          borderRadius: 10,
        }}
      />
    </label>
  );

  return (
    <form onSubmit={submit} style={{ display: "grid", gap: 14 }}>
      {input("birth", "Nacimiento", "date")}
      {input("phone", "Teléfono")}
      {input("curp", "CURP")}
      {input("rfc", "RFC")}
      {input("nss", "NSS")}
      <div
        style={{
          display: "flex",
          gap: 8,
          justifyContent: "flex-end",
          marginTop: 8,
        }}
      >
        <button type="button" className="btn-secondary" onClick={onCancel}>
          Cancelar
        </button>
        <button type="submit" className="new-task-button">
          Guardar
        </button>
      </div>
    </form>
  );
}
